import { notify } from 'utils/reduxUtils';

export const types = {
  UPDATE_DEFAULT_ORGANIZATION_ERROR:
    'settings/userProfile/UPDATE_DEFAULT_ORGANIZATION_ERROR',
  UPDATE_DEFAULT_ORGANIZATION_REQUEST:
    'settings/userProfile/UPDATE_DEFAULT_ORGANIZATION_REQUEST',
  UPDATE_DEFAULT_ORGANIZATION_SUCCESS:
    'settings/userProfile/UPDATE_DEFAULT_ORGANIZATION_SUCCESS',
};

export const updateDefaultOrganization = {
  error: notify(
    (error) => ({
      type: types.UPDATE_DEFAULT_ORGANIZATION_ERROR,
      payload: error,
    }),
    "Can't update default organization",
  ),
  request: ({ defaultOrganizationId }) => {
    return {
      type: types.UPDATE_DEFAULT_ORGANIZATION_REQUEST,
      payload: defaultOrganizationId,
    };
  },
  success: notify(
    () => ({
      type: types.UPDATE_DEFAULT_ORGANIZATION_SUCCESS,
    }),
    'Default organization updated successfully',
  ),
};
